"use strict";
import classNames from "classnames";
import format from "../formatters/documents";
import reactUtils from "../react_utils";
import pageHelper from "../helpers/document_pages";
import Auth from "../util/auth";
var bem = reactUtils.makeBem("document-thumbnail");
export default React.createClass({
  propTypes: {
    document: React.PropTypes.object.isRequired,
    selectedPages: React.PropTypes.array.isRequired,
    pageSelected: React.PropTypes.func.isRequired,
    variant: React.PropTypes.string,
    firstPageOnly: React.PropTypes.bool,
    isDocumentGrouper: React.PropTypes.bool
  },
  render: function() {
    var hash = {};
    hash[bem()] = true;
    var classes = classNames(hash);
    var maxTitleWidth = 120 * this.props.document.pages.length;
    const hideTitle = !this.props.isDocumentGrouper && Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled;
    const title = hideTitle ? "" : format.title(this.props.document);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classes,
        title: this.hotkeyTooltipHint(),
        "data-document-id": this.props.document.id
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: this.classForTitle(),
          style: { maxWidth: maxTitleWidth },
          onClick: _.partial(this.props.pageSelected, this.firstPage()),
          onContextMenu: _.partial(this.contextMenu, this.firstPage())
        },
        title
      ),
      /* @__PURE__ */ React.createElement("div", { className: this.classForPages() }, _.map(this.pages(), this.documentPage))
    );
  },
  hasGroupingErrors: function() {
    return (this.props.document.data["grouping_errors"] || []).length > 0;
  },
  pages: function() {
    if (this.props.firstPageOnly) {
      return [this.firstPage()];
    }
    return this.props.document.pages;
  },
  firstPage: function() {
    return _.first(this.props.document.pages);
  },
  documentPage: function(page, index) {
    var classForPageContainer = bem("__page-container");
    var classesForLabelContainer = [bem("__page-label-container"), "enable_shared-ui-v3"];
    return /* @__PURE__ */ React.createElement("div", { key: "document-page-" + index, className: classForPageContainer }, /* @__PURE__ */ React.createElement(
      "img",
      {
        className: this.classForPage(page),
        src: pageHelper.thumbnail(page),
        crossOrigin: "anonymous",
        onContextMenu: _.partial(this.contextMenu, page),
        onClick: _.partial(this.pageSelected, page)
      }
    ), /* @__PURE__ */ React.createElement("div", { className: classNames(classesForLabelContainer) }, /* @__PURE__ */ React.createElement("div", { className: "v3__theme" }, this.labelsForPage(page, index))));
  },
  labelsForPage: function(page, index) {
    const divClasses = [bem("__page-label"), "v3__descriptor-tag"];
    const labelDivs = [];
    if (this.props.document.is_pod && index == 0) {
      const podClasses = [...divClasses, "v3__descriptor-tag--color-success"];
      labelDivs.push(/* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: classNames(podClasses) }, "POD")));
    }
    if (this.props.document.is_signed && index == 0) {
      const hiddenClasses = [...divClasses, "v3__descriptor-tag--color-info"];
      labelDivs.push(/* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: classNames(hiddenClasses) }, "Signed")));
    }
    if (this.props.document.has_reference_number && index == 0) {
      const hiddenClasses = [...divClasses, "v3__descriptor-tag--color-info"];
      labelDivs.push(/* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: classNames(hiddenClasses) }, "Ref #")));
    }
    if (this.props.document.hidden && index == 0) {
      const hiddenClasses = [...divClasses, "v3__descriptor-tag--color-alert"];
      labelDivs.push(/* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: classNames(hiddenClasses) }, "Hidden")));
    }
    if (page.illegible) {
      const illegibleClasses = [...divClasses, "v3__descriptor-tag--color-alert"];
      labelDivs.push(/* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: classNames(illegibleClasses) }, "Illegible")));
    }
    return labelDivs;
  },
  selectedPages() {
    return this.props.selectedPages;
  },
  pageIsSelected(page) {
    return !_.isEmpty(_.findWhere(this.selectedPages(), { id: page.id }));
  },
  pageSelected(page, event) {
    if (event.shiftKey) {
      this.props.pageSelected(page, { action: "add" });
    } else {
      this.props.pageSelected(page, { action: "replace" });
    }
  },
  closeMenu: function() {
    this.setState({ menuComponent: null });
  },
  contextMenu: function(page, event) {
    if (this.props.onContextMenu) {
      event.preventDefault();
      this.props.onContextMenu(page);
    }
  },
  hotkeyTooltipHint: function() {
    if (!this.props.isDocumentGrouper) {
      return "Go to next page - PgDn or Alt+P\nGo to previous page- PgUp or Alt+Shift+P";
    }
  },
  classForPages: function() {
    return bem({
      "__pages": true,
      "__pages--group-editor-window": this.props.variant === "--horizontal"
    });
  },
  classForPage: function(page) {
    return bem({
      "__page": true,
      "__page--selected": this.pageIsSelected(page)
    });
  },
  classForTitle: function() {
    return bem({
      "__title": true,
      "__grouping-error-title": this.hasGroupingErrors(),
      "__title--group-editor-window": this.props.variant === "--horizontal"
    });
  }
});
